import apache from './../skills/apache.png'
import cpanel from './../skills/cpanel.png'
import heroku from './../skills/heroku.png'
import netlify from './../skills/netlify.png'
import nginx from './../skills/nginx.png'


const IconsWeb = [
    { name: "apache" , src: apache },
    { name: "cpanel" , src: cpanel },
    { name: "heroku", src: heroku },
    { name: "netlify", src: netlify },
    { name: "nginx", src: nginx },
];

export default IconsWeb ;

